import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'

function Returns() {
  const [loading, setLoading] = useState(true)
  return (
    <div style={{width:"100%",height:"100vh",display:"flex",justifyContent:"center",alignItems:"center"}}>
    {loading ? <div style={{margin:"auto",display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",gap:"5px"}}>

      <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQzg30UJ6wuvzvWf3S-MNDRqyAugtDzdJW9Yw&s' width="200px" height="150px"/>
      <h3>You have no Return Product</h3>
      <p>We have thousands of items available across our wide range of sellers. Start ordering today!</p>
      <button style={{backgroundColor:"blueviolet",border:"none",borderRadius:"5px",color:"white",padding:"10px 20px"}}>Start Shopping</button>
    </div>:<>
    
    </>}
  </div>
  )
}

export default Returns